module.exports = __webpack_public_path__ + "img/banner_5.d86b237b.jpg";